<script lang="ts" setup>
	import type { DateFilterParameter } from '@/components/Forms/date-filter.vue'
	import { useWellnessApi } from '@/services/apis/wellness'
	import type { RecordSchema, TableFilterOptions } from '@/types'

	const props = defineProps<{ category: string }>()
	const { formatDate } = useCustomDate()
	const tableCol: TableColumn[] = [
		{
			title: 'Employee',
			key: 'employee',
			dataIndex: 'employee',
			customHeaderCell: () => ({ class: 'text-xs' })
		},
		{
			title: 'Facility',
			key: 'facility',
			dataIndex: ['facility', 'name'],
			customHeaderCell: () => ({ class: 'text-xs' }),
			customRender: ({ text }) => renderItem(truncateWords(text, 8))
		},
		{
			title: 'Date',
			key: 'date',
			dataIndex: 'date',
			customHeaderCell: () => ({ class: 'text-xs' }),
			customRender: ({ text }) => renderItem(formatDate(text))
		},
		{
			title: 'Time',
			key: 'time',
			dataIndex: 'time',
			customHeaderCell: () => ({ class: 'text-xs' }),
			customRender: ({ text }) => renderItem(text)
		},
		{
			title: 'Ratings',
			key: 'rating',
			dataIndex: 'rating',
			customHeaderCell: () => ({ class: 'text-xs' })
		}
	]
	const { gymSpaHistory } = useWellnessApi()
	const filterValue = ref<Partial<DateFilterParameter>>({
		start_date: '',
		end_date: ''
	})

	const tableOption = computed<TableFilterOptions>(() => ({
		filter: {
			...filterValue.value,
			category: props.category
		},
		watch: [filterValue.value]
	}))
</script>

<template>
	<div>
		<forms-date-filter v-model:value="filterValue" placeholder="Date" :filter-just-date="true" />
		<ui-data-table :columns="tableCol" :records="e => gymSpaHistory({ ...e, category })" :options="tableOption">
			<template #bodyCell="{ column, text }">
				<wellness-status v-if="column.key === 'status'" :status="text" />
				<ui-rating-star
					v-if="column.key === 'rating'"
					:rating="Number(text || 0)"
					class="inline-flex items-center gap-1.5"
				/>
			</template>
		</ui-data-table>
	</div>
</template>
